<template>
  <div class="content-orders">
    <div class="page-header" v-if="scene === 'default'">
      <h2>{{ userType === 'schoolAdmin' ? 'School Content Orders' : 'My Content Orders' }}</h2>
    </div>

    <el-card class="orders-card">
      <div class="filters" v-if="scene === 'default'">
        <el-select
          v-model="selectedClub"
          placeholder="Filter by Club"
          clearable
          class="filter-item"
        >
          <el-option
            label="All Clubs"
            value=""
          />
          <el-option
            v-for="club in uniqueClubs"
            :key="club.id"
            :label="club.name"
            :value="club.id"
          />
        </el-select>

        <el-select
          v-model="selectedContent"
          placeholder="Filter by Content"
          clearable
          class="filter-item"
        >
          <el-option
            label="All Contents"
            value=""
          />
          <el-option
            v-for="content in uniqueContents"
            :key="content.id"
            :label="content.title"
            :value="content.id"
          />
        </el-select>
      </div>

      <el-table 
        v-loading="loading"
        :data="filteredOrders"
        style="width: 100%"
      >
        <el-table-column label="Content" min-width="300">
          <template slot-scope="scope">
            <div class="content-info">
              <img 
                v-if="scope.row.content_info?.cover_url" 
                :src="scope.row.content_info?.cover_url" 
                class="content-cover"
                alt="Content cover"
              />
              <div class="content-details">
                <span class="content-type" :class="scope.row.content_type">
                  {{ scope.row.content_type }}
                </span>
                <router-link
                  :to="{
                    name: scope.row.content_type === 'bundle' ? 'Bundle Detail' : 'Content Profile',
                    query: { 
                      [scope.row.content_type === 'bundle' ? 'bundle_id' : 'content_id']: scope.row.content_id 
                    }
                  }"
                  class="content-title"
                >
                  {{ scope.row.content_info?.title }}
                </router-link>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="For Club" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.club_name }}
          </template>
        </el-table-column>

        <el-table-column prop="quantity" label="Copies" width="100" align="center">
        </el-table-column>

        <el-table-column label="Amount" width="120" align="center">
          <template slot-scope="scope">
            ${{ scope.row.total_price.toFixed(2) }}
          </template>
        </el-table-column>

        <el-table-column prop="order_time" label="Order Date" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.order_time * 1000) }}
          </template>
        </el-table-column>

        <el-table-column label="Status" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>

        

        <el-table-column label="Actions" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 'PENDING'"
              type="primary"
              size="small"
              @click="goToPayment(scope.row)"
            >
              Pay Now
            </el-button>
            <el-button
              v-else-if="scope.row.status === 'COMPLETED'"
              type="text"
              size="small"
              @click="viewCopies(scope.row)"
            >
              View Copies
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="empty-state" v-if="!loading && orders.length === 0">
        <i class="el-icon-document"></i>
        <p>No orders found</p>
        <el-button type="primary" @click="goToContents">Browse Contents</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
import { getUserId,getUserType } from '@/utils/store'

export default {
  name: 'ContentOrders',
  props: {
    club_id: {
      type: String,
      default: ''
    },
    scene: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      orders: [],
      loading: false,
      selectedClub: this.club_id,
      selectedContent: '',
      pendingFilters: {
        clubId: null,
        contentId: null
      },
      userType: getUserType()
    }
  },
  computed: {
    uniqueClubs() {
      const clubMap = new Map()
      this.orders.forEach(order => {
        if (!clubMap.has(order.club_id)) {
          clubMap.set(order.club_id, {
            id: order.club_id,
            name: order.club_name
          })
        }
      })
      return Array.from(clubMap.values())
    },
    uniqueContents() {
      const contentMap = new Map()
      this.orders.forEach(order => {
        if (!contentMap.has(order.content_id)) {
          contentMap.set(order.content_id, {
            id: order.content_id,
            title: order.content_info?.title
          })
        }
      })
      return Array.from(contentMap.values())
    },
    filteredOrders() {
      return this.orders.filter(order => {
        const matchesClub = !this.selectedClub || order.club_id === this.selectedClub
        const matchesContent = !this.selectedContent || order.content_id === this.selectedContent
        return matchesClub && matchesContent
      })
    }
  },
  created() {
    const queryClubId = this.$route.query.club_id
    const queryContentId = this.$route.query.content_id

    // Set filters after orders are loaded to validate IDs
    this.$nextTick(async () => {
      await this.fetchOrders()
      
      if (queryClubId) {
        // const clubExists = this.uniqueClubs.some(club => club.id === queryClubId)
        // this.selectedClub = clubExists ? queryClubId : ''
        this.selectedClub = queryClubId
      }
      
      console.log('Selected Club:', queryContentId)
      if (queryContentId) {
        // const contentExists = this.uniqueContents.some(content => content.id === queryContentId)
        // this.selectedContent = contentExists ? queryContentId : ''
        this.selectedContent = queryContentId

        // console.log('Selected Content:', this.selectedContent)
      }
    })
  },
  watch: {
    // orders: {
    //   immediate: true,
    //   handler(newOrders) {
    //     if (newOrders.length && this.pendingFilters.clubId) {
    //       const matchingOrder = newOrders.find(order => order.club_id === this.pendingFilters.clubId)
    //       if (matchingOrder) {
    //         this.selectedClub = matchingOrder.club_name
    //       }
    //       this.pendingFilters.clubId = null
    //     }
    //     if (newOrders.length && this.pendingFilters.contentId) {
    //       const matchingOrder = newOrders.find(order => order.content_id === this.pendingFilters.contentId)
    //       if (matchingOrder) {
    //         this.selectedContent = matchingOrder.content_info?.title
    //       }
    //       this.pendingFilters.contentId = null
    //     }
    //   }
    // }
  },
  methods: {
    async fetchOrders() {
      console.log('User Type'+getUserType())
      this.loading = true
      try {
        const userType = getUserType() // Assuming user type is stored in Vuex
        const payload = userType === 'schoolAdmin' 
          ? { account_id: getUserId() }
          : { contact_id: getUserId() }

        const endpoint = userType === 'schoolAdmin' 
          ? 'getAccountContentOrders'
          : 'getContactContentOrders'

        const response = await postRequest(endpoint, payload)
        
        if (response.data.code === 0) {
          this.orders = response.data.data
        }
      } catch (error) {
        console.error('Error fetching orders:', error)
        this.$message.error('Failed to load orders')
      } finally {
        this.loading = false
      }
    },
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleString()
    },
    getStatusType(status) {
      const types = {
        PENDING: 'warning',
        COMPLETED: 'success',
        FAILED: 'danger'
      }
      return types[status] || 'info'
    },
    goToPayment(order) {
      this.$router.push({
        name: 'Content Payment',
        query: { order_id: order._id.$id }
      })
    },
    viewCopies(order) {
      this.$router.push({
        name: 'Content Copy',
        query: { 
          content_id: order.content_id,
          club_id: order.club_id 
        }
      })
    },
    goToContents() {
      this.$router.push({ name: 'Find Contents' })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-orders {
  padding: 20px;

  .page-header {
    margin-bottom: 20px;

    h2 {
      margin: 0;
      color: #303133;
    }
  }

  .orders-card {
    .filters {
      margin-bottom: 20px;
      display: flex;
      gap: 16px;

      .filter-item {
        width: 200px;
      }
    }
    .content-info {
      display: flex;
      align-items: center;
      gap: 12px;

      .content-cover {
        width: 40px;
        height: 56px;
        object-fit: cover;
        border-radius: 4px;
      }

      .content-details {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .content-type {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
          text-transform: capitalize;

          &.events {
            background-color: #e1f3d8;
            color: #67c23a;
          }

          &.posts {
            background-color: #fdf6ec;
            color: #e6a23c;
          }

          &.achievements {
            background-color: #f0f9eb;
            color: #67c23a;
          }
        }

        .content-title {
          color: #303133;
        }
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    i {
      font-size: 48px;
      margin-bottom: 16px;
    }

    p {
      margin: 0 0 20px;
      font-size: 16px;
    }
  }
}
</style> 